



































































import { defineComponent, computed } from '@nuxtjs/composition-api';
import {
  TypeDisplay,
  BaseTag,
  TypeBody,
  BaseButton,
  BaseDivider,
} from '@bambeehr/pollen';
import BambeeHex from '@/assets/images/bambee-hex.svg';
import { getTag } from '@/modules/InformationPages/Blog/utils/tags';

export default defineComponent({
  name: 'BlogCard',
  components: {
    TypeDisplay,
    BaseTag,
    TypeBody,
    BaseButton,
    BaseDivider,
    BambeeHex,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    posterImage: {
      type: String,
      required: true,
    },
    tags: {
      type: Array as () => string[],
      required: true,
    },
    fullName: {
      type: String,
      required: true,
    },
    primary: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const tagsToShow = computed(() => props.tags?.slice(0, 2));

    const titleToShow = computed(() => {
      return props.title.length > 60
        ? `${props.title.slice(0, 50)}...`
        : props.title;
    });

    return {
      getTag,
      tagsToShow,
      titleToShow,
    };
  },
});
